<template>
  <div>
    <div style="margin: 5px">
      <label class="d-flex">
        {{ $t('settings.emailAdress') }}

      </label>
      <BFormInput
        v-model="email"
        :disabled="!!user"
        :placeholder="$t('settings.emailAdress')"
        size="sm"
      />
    </div>

    <hr>
    <div
      v-for="role in userRoles"
      :key="role.id"
      class="role-row d-flex align-items-center"
    >
      <div class="pr-2">
        <i :class="role.type.icon" />
      </div>
      <div
        class="flex-grow-1 small"
      >
        <div>
          {{ role.type.text }}
        </div>
        <div class="text-secondary">
          {{ role.scopes.join(', ') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    user: Object,
    tenantId: String,
    pending: Boolean,
  },
  data: () => ({
    email: '',
    list: [],
    newRole: null,
  }),
  computed: {
    ...mapGetters('shop', ['catalogs']),
    ...mapGetters([
      'roleTypes',
      'groups',
      'payee',
      'payeeId',
    ]),
    userRoles() {
      return Object.entries(this.list
        .reduce((acc, curr) => {
          if (acc[curr.type]) {
            acc[curr.type].push(curr);
          } else {
            acc[curr.type] = [curr];
          }
          return acc;
        },
        {}))
        .map(([key, value]) => ({
          type: this.roleTypes.find((y) => y.key === key),
          scopes: value.map((x) => this.getScopeName(key, x.scope)),
        }));
    },
    groupOptions() {
      return (this.groups || [])
        .map((x) => ({
          value: `${this.payeeId}|${x.code}`,
          text: x.code === '#all'
            ? this.$t('company.all')
            : x.path,
        }));
    },
  },
  methods: {
    ...mapActions([
      'addPayeeRole',
      'removePayeeRole',
    ]),
    cancel() {
      this.$emit('update:pending', false);
      this.newRole = null;
    },
    toggleRemove({ id, added }) {
      if (added) {
        this.newRoles = this.newRoles.filter((x) => `${x.type}_${x.scope}` !== id);
        return;
      }

      if (this.toRemove.includes(id)) {
        this.toRemove = this.toRemove.filter((x) => x !== id);
      } else {
        this.toRemove.push(id);
      }
    },
    getScopeName(key, scope) {
      if (key === 'PayersView' || key === 'ShopOrdersView' || key === 'PayersMessageView') {
        return this.groupOptions.find((x) => x.value === scope)?.text ?? '?';
      }
      if (key === 'BillingCategoryView') {
        const parts = scope.split('|');
        return this.payee.categories.find((x) => x.id === parts[1])?.name ?? '?';
      }
      if (key === 'ShopCatalogAdmin') {
        const parts = scope.split('|');
        return this.catalogs.find((x) => x.id === parts[1])?.name ?? '?';
      }
      return '';
    },
    submit() {
      const email = this.user?.email || this.email;
      const removals = this.toRemove
        .map((id) => this.userRoles.find((y) => id === y.id))
        .map((role) => this.removePayeeRole({
          params: {
            tenantId: this.tenantId,
          },
          data: {
            email,
            roleType: role.type.key,
            scope: role.scope,
            payeeId: this.payeeId,
          },
        }));

      const additions = this.newRoles
        .map((role) => this.addPayeeRole({
          params: {
            tenantId: this.tenantId,
          },
          data: {
            email,
            roleType: role.type,
            scope: role.scope,
            payeeId: this.payeeId,
          },
        }));

      this.$emit('update:pending', true);
      Promise.all([
        ...removals,
        ...additions,
      ])
        .then(() => {
          this.$emit('refresh');
          this.$emit('close');
          this.$emit('update:pending', false);
        });
    },
    init() {
      if (this.user) {
        this.email = this.user.email;
        this.list = (this.user.list || []).slice();
      }
      this.toRemove = [];
      this.newRoles = [];
      this.newRole = null;
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.role-row {
  padding: 5px 10px;
  border: 2px solid #eee;
  border-radius: 15px;
  margin: 5px;

  &.active {
    border-color: $blue;
    background-color: rgba($blue, 0.1);
  }
}

.text-strikethrough {
  text-decoration: line-through;
}

.role-remove {
  cursor: pointer;

  &:hover {
    color: $red;
  }
}
</style>
